<template>
  <baseEdit></baseEdit>
</template>
<script>
  import baseEdit from './index.vue';

  export default {
    components: {
      baseEdit,
    },
    name: 'otherContractCopy',
  };
</script>
